import { FileBarChart, Loader2 } from 'lucide-react';
import { AdminPageHeader, StatCard, useFetcher } from './_P1Common';

export default function AdminAdReports() {
  const { data, loading } = useFetcher('ad-reports');
  if (loading || !data) return <AdminPageHeader icon={FileBarChart} title="Izvješće o oglasima"><Loader2 className="animate-spin"/></AdminPageHeader>;
  return (
    <div data-testid="admin-ad-reports">
      <AdminPageHeader icon={FileBarChart} title="Izvješće o oglasima" subtitle="Impresije i klikovi po slotu"/>
      <div className="px-4 md:px-6 mb-6 grid grid-cols-2 md:grid-cols-3 gap-3">
        <StatCard testid="ads-total" label="Ukupno impresija" value={data.total_impressions} accent="blue"/>
      </div>
      <div className="px-4 md:px-6 pb-6 overflow-x-auto rounded-lg border border-zinc-800 mx-4 md:mx-6">
        <table className="min-w-full text-sm">
          <thead className="bg-zinc-900 text-xs text-zinc-400 uppercase">
            <tr>
              <th className="px-4 py-2 text-left">Slot</th>
              <th className="px-4 py-2 text-left">Impresije</th>
              <th className="px-4 py-2 text-left">Klikovi</th>
              <th className="px-4 py-2 text-left">CTR</th>
            </tr>
          </thead>
          <tbody>
            {(data.by_slot || []).map(s => (
              <tr key={s.slot} className="border-t border-zinc-800">
                <td className="px-4 py-2">{s.slot}</td>
                <td className="px-4 py-2">{s.impressions}</td>
                <td className="px-4 py-2">{s.clicks}</td>
                <td className="px-4 py-2 text-xs text-zinc-400">{s.impressions ? ((s.clicks / s.impressions) * 100).toFixed(2) : '0'}%</td>
              </tr>
            ))}
            {(data.by_slot || []).length === 0 && (
              <tr><td colSpan={4} className="px-4 py-8 text-center text-zinc-500">Nema podataka.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
